exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".reviewer-image-wrapper-1BN6De{display:block;line-height:45px;border-radius:50%;width:45px;height:45px;margin-right:10px}.reviewer-image-wrapper-1BN6De img.svelte-x4kuua{width:45px;border-radius:50%}", ""]);
